import { render, staticRenderFns } from "./ClientProfileKpis.vue?vue&type=template&id=92aab3bc&scoped=true&"
import script from "./ClientProfileKpis.vue?vue&type=script&lang=js&"
export * from "./ClientProfileKpis.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileKpis.vue?vue&type=style&index=0&id=92aab3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aab3bc",
  null
  
)

export default component.exports